module.exports = __webpack_public_path__ + "static/img/fruits_berry1.df8b5d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_berry1.png
// module id = RgRM
// module chunks = 1